export default "__VITE_ASSET__dacdd378__"